import PropTypes from 'prop-types';
import { Icon } from '@evertrue/et-components';
import StrikeThroughWrapper from 'components/containers/strikethrough-wrapper';
import { daysFromNow } from 'apps/tasks/utils/utils';

const TaskDueDateCell = ({ task }) => {
  if (!task) return null;

  const { current_due_date, completed_at, contact_journey_id, static_due_date } = task;

  if (!current_due_date) {
    return <span>-</span>;
  }

  const due = daysFromNow(current_due_date);

  return (
    <StrikeThroughWrapper hasStrikeThrough={!!completed_at}>
      <span className="tasks--due-date">
        <p style={due.style}>
          {due.date}
          {!contact_journey_id && static_due_date && <Icon icon="lock" />}
        </p>
      </span>
    </StrikeThroughWrapper>
  );
};

TaskDueDateCell.propTypes = {
  task: PropTypes.object.isRequired,
};

export default TaskDueDateCell;
